import { render } from "./VerifyEmail.vue?vue&type=template&id=b9b4a23e"
import script from "./VerifyEmail.vue?vue&type=script&scoped=true&lang=js"
export * from "./VerifyEmail.vue?vue&type=script&scoped=true&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__